export var LuxStatusEnum;
(function (LuxStatusEnum) {
    LuxStatusEnum["primary"] = "primary";
    LuxStatusEnum["secondary"] = "secondary";
    LuxStatusEnum["success"] = "success";
    LuxStatusEnum["warning"] = "warning";
    LuxStatusEnum["danger"] = "danger";
    LuxStatusEnum["dark"] = "dark";
    LuxStatusEnum["shade"] = "shade";
    LuxStatusEnum["neutral"] = "neutral";
    LuxStatusEnum["subtle"] = "subtle";
    LuxStatusEnum["brand"] = "brand";
    LuxStatusEnum["brandAlt"] = "brandAlt";
    LuxStatusEnum["flat"] = "flat";
    LuxStatusEnum["flatAlt"] = "flatAlt";
    LuxStatusEnum["info"] = "info";
    LuxStatusEnum["basic"] = "basic";
    LuxStatusEnum["warningAlt"] = "warningAlt";
    LuxStatusEnum["dangerAlt"] = "dangerAlt";
    LuxStatusEnum["darkAlt"] = "darkAlt";
    LuxStatusEnum["slate"] = "slate";
})(LuxStatusEnum || (LuxStatusEnum = {}));
export const LuxStatusKeys = Object.keys(LuxStatusEnum);
export var LuxSizeEnum;
(function (LuxSizeEnum) {
    LuxSizeEnum["xlarge"] = "xlarge";
    LuxSizeEnum["large"] = "large";
    LuxSizeEnum["medium"] = "medium";
    LuxSizeEnum["small"] = "small";
    LuxSizeEnum["tiny"] = "tiny";
})(LuxSizeEnum || (LuxSizeEnum = {}));
export const LuxSizeKeys = Object.keys(LuxSizeEnum);
export var LuxSurfaceEnum;
(function (LuxSurfaceEnum) {
    LuxSurfaceEnum["filled"] = "filled";
    LuxSurfaceEnum["outline"] = "outline";
    LuxSurfaceEnum["ghost"] = "ghost";
    LuxSurfaceEnum["ghostAlt"] = "ghostAlt";
    LuxSurfaceEnum["outlineAlt"] = "outlineAlt";
})(LuxSurfaceEnum || (LuxSurfaceEnum = {}));
export const LuxSurfaceKeys = Object.keys(LuxSurfaceEnum);
//# sourceMappingURL=types.js.map